__turbopack_context__.v({
  "cardHolder": "meeting-place-page-home-module-scss-module__14hAkG__cardHolder",
  "cardHolderNoCrowd": "meeting-place-page-home-module-scss-module__14hAkG__cardHolderNoCrowd",
});
